export enum AppTypeEnum {
    PSD2 = 'PSD2',
    BANKID = 'BANKID'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/enums/app-type.enum.ts